var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "day-report-wrap" },
    [
      _c(
        "handleIcon",
        {
          attrs: { isAllScreen: _vm.isAllScreen },
          on: {
            allScreen: function ($event) {
              return _vm.toggleAllScreenFull(!_vm.isAllScreen)
            },
          },
        },
        [
          _c("template", { slot: "menu" }, [
            _c(
              "li",
              {
                on: {
                  click: function () {
                    return _vm.getAllData()
                  },
                },
              },
              [
                _c("div", { staticClass: "icon" }, [
                  _c("i", { staticClass: "iconfont iconRefresh" }),
                ]),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("dashboard-bi::default-board::refresh"))
                  ),
                ]),
              ]
            ),
          ]),
        ],
        2
      ),
      _vm.$store.state.user.sourceType !== 2
        ? _c("tooltipLine", {
            attrs: {
              visible: !(
                _vm.$store.state.user.hasBindData &&
                _vm.$store.state.user.hasBindData.isExistShop
              ),
              content: "看板没有数据？快来绑定您的店铺，系统就会自动拉取数据啦",
              showClose: false,
            },
          })
        : _vm._e(),
      _c(
        "el-card",
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c("label", { staticClass: "label-item" }, [
                    _vm._v(
                      _vm._s(_vm.$t("operate-analysis::day-report::shop_name"))
                    ),
                  ]),
                  _c(
                    "el-select",
                    {
                      staticClass: "search-item",
                      attrs: {
                        placeholder: _vm.$t(
                          "system::common::select_placeholder"
                        ),
                        popperAppendToBody: false,
                        filterable: "",
                        clearable: "",
                      },
                      on: { change: _vm.changeShop },
                      model: {
                        value: _vm.params.shopId,
                        callback: function ($$v) {
                          _vm.$set(_vm.params, "shopId", $$v)
                        },
                        expression: "params.shopId",
                      },
                    },
                    _vm._l(_vm.shopList, function (item) {
                      return _c("el-option", {
                        key: item.shopId,
                        attrs: { label: item.shopName, value: item.shopId },
                      })
                    }),
                    1
                  ),
                  _c("label", { staticClass: "label-item" }, [
                    _vm._v(
                      _vm._s(_vm.$t("operate-analysis::day-report::time"))
                    ),
                  ]),
                  _c("el-date-picker", {
                    staticClass: "day-item",
                    attrs: {
                      appendToBody: false,
                      clearable: false,
                      format: "yyyy-MM-dd",
                      type: "date",
                      "unlink-panels": "",
                    },
                    on: { change: _vm.handlerDateChange },
                    model: {
                      value: _vm.params.dt,
                      callback: function ($$v) {
                        _vm.$set(_vm.params, "dt", $$v)
                      },
                      expression: "params.dt",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 16 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("dayCardList", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.cardLoading,
                    expression: "cardLoading",
                  },
                ],
                attrs: { cardData: _vm.cardOptions },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 24, md: 24, sm: 24, xl: 24 } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("reportCard", {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.timeCardLoading,
                            expression: "timeCardLoading",
                          },
                        ],
                        attrs: { config: _vm.timeOrderData },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("reportCard", {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.timeCardLoading,
                            expression: "timeCardLoading",
                          },
                        ],
                        attrs: { config: _vm.timePriceData },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 24, md: 24, sm: 24, xl: 24 } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("RangeCard", {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.salesTopLoading,
                            expression: "salesTopLoading",
                          },
                        ],
                        style: "height: " + _vm.tableHeight + ";",
                        attrs: { config: _vm.salesTopConfig },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "reportTable",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.tableLoading.shop,
                              expression: "tableLoading.shop",
                            },
                          ],
                          ref: "shopSale",
                          style: "height: " + _vm.tableHeight + ";",
                          attrs: { config: _vm.shopTableConfig },
                          on: {
                            onEnd: _vm.onShopTableEnd,
                            btns: _vm.onReportBtns,
                            "sort-change": _vm.shopSortChange,
                          },
                        },
                        [
                          _vm._l(
                            _vm.shopTableConfig.columns,
                            function (item, index) {
                              return [
                                _c(
                                  "el-table-column",
                                  {
                                    key: index,
                                    attrs: {
                                      label: item,
                                      "min-width": "150",
                                      prop: item,
                                      sortable: "custom",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              /((\.(png|jpg|gif|svg|jpeg)(\?.*|\/.*)?)|(\?viewid=.*)$)|(\/file\/([^\.]+)\.)/i.test(
                                                scope.row[item]
                                              )
                                                ? _c(
                                                    "el-popover",
                                                    {
                                                      staticStyle: {
                                                        "margin-right": "24px",
                                                      },
                                                      attrs: {
                                                        placement: "top-start",
                                                        trigger: "hover",
                                                      },
                                                    },
                                                    [
                                                      _c("ZImg", {
                                                        staticStyle: {
                                                          width: "250px",
                                                          height: "250px",
                                                        },
                                                        attrs: {
                                                          src: scope.row[item],
                                                        },
                                                      }),
                                                      _c("ZImg", {
                                                        staticClass:
                                                          "goods-image",
                                                        attrs: {
                                                          slot: "reference",
                                                          src: scope.row[item],
                                                        },
                                                        slot: "reference",
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$dataCheck(
                                                          scope.row[item]
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "template",
                                      { slot: "header" },
                                      [
                                        _vm._v(" " + _vm._s(item) + " "),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              placement: "top-start",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content",
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.shopTableConfig &&
                                                        _vm.shopTableConfig
                                                          .headerTooltip[item]
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c("i", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.shopTableConfig &&
                                                    _vm.shopTableConfig
                                                      .headerTooltip[item],
                                                  expression:
                                                    "shopTableConfig && shopTableConfig.headerTooltip[item]",
                                                },
                                              ],
                                              staticClass:
                                                "icon-a-01wenhao iconfont-el table-tooltip",
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            }
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 24, md: 24, sm: 24, xl: 24 } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("RangeCard", {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.spuSalesTopLoading,
                            expression: "spuSalesTopLoading",
                          },
                        ],
                        style: "height: " + _vm.tableHeight + ";",
                        attrs: { config: _vm.spuSalesTopConfig },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "reportTable",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.tableLoading.spu,
                              expression: "tableLoading.spu",
                            },
                          ],
                          ref: "spuSale",
                          style: "height: " + _vm.tableHeight + ";",
                          attrs: { config: _vm.spuTableConfig },
                          on: {
                            onEnd: _vm.onSpuTableEnd,
                            btns: _vm.onReportBtns,
                            "sort-change": _vm.spuSortChange,
                          },
                        },
                        [
                          _vm._l(
                            _vm.spuTableConfig.columns,
                            function (item, index) {
                              return [
                                _c(
                                  "el-table-column",
                                  {
                                    key: index,
                                    attrs: {
                                      label: item,
                                      "min-width": "160",
                                      prop: item,
                                      sortable: item !== "SPU图" && "custom",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              /((\.(png|jpg|gif|svg|jpeg)(\?.*|\/.*)?)|(\?viewid=.*)$)|(\/file\/([^\.]+)\.)/i.test(
                                                scope.row[item]
                                              )
                                                ? _c(
                                                    "el-popover",
                                                    {
                                                      staticStyle: {
                                                        "margin-right": "24px",
                                                      },
                                                      attrs: {
                                                        placement: "top-start",
                                                        trigger: "hover",
                                                      },
                                                    },
                                                    [
                                                      _c("ZImg", {
                                                        staticStyle: {
                                                          width: "250px",
                                                          height: "250px",
                                                        },
                                                        attrs: {
                                                          src: scope.row[item],
                                                        },
                                                      }),
                                                      _c("ZImg", {
                                                        staticClass:
                                                          "goods-image",
                                                        attrs: {
                                                          slot: "reference",
                                                          src: scope.row[item],
                                                        },
                                                        slot: "reference",
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$dataCheck(
                                                          scope.row[item]
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "template",
                                      { slot: "header" },
                                      [
                                        _vm._v(" " + _vm._s(item) + " "),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              placement: "top-start",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content",
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.spuTableConfig &&
                                                        _vm.spuTableConfig
                                                          .headerTooltip[item]
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c("i", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.spuTableConfig &&
                                                    _vm.spuTableConfig
                                                      .headerTooltip[item],
                                                  expression:
                                                    "spuTableConfig && spuTableConfig.headerTooltip[item]",
                                                },
                                              ],
                                              staticClass:
                                                "icon-a-01wenhao iconfont-el table-tooltip",
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            }
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 24, md: 24, sm: 24, xl: 24 } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("RangeCard", {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.optimizerTopLoading,
                            expression: "optimizerTopLoading",
                          },
                        ],
                        style: "height: " + _vm.tableHeight + ";",
                        attrs: { config: _vm.optimizerTopConfig },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "reportTable",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.tableLoading.optimizer,
                              expression: "tableLoading.optimizer",
                            },
                          ],
                          ref: "optimizerSale",
                          style: "height: " + _vm.tableHeight + ";",
                          attrs: { config: _vm.optimizerTableConfig },
                          on: {
                            onEnd: _vm.onOptimizerTableEnd,
                            btns: _vm.onReportBtns,
                            "sort-change": _vm.optimizerSortChange,
                          },
                        },
                        [
                          _vm._l(
                            _vm.optimizerTableConfig.columns,
                            function (item, index) {
                              return [
                                _c(
                                  "el-table-column",
                                  {
                                    key: index,
                                    attrs: {
                                      label: item,
                                      "min-width": "150",
                                      prop: item,
                                      sortable: "custom",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              /((\.(png|jpg|gif|svg|jpeg)(\?.*|\/.*)?)|(\?viewid=.*)$)|(\/file\/([^\.]+)\.)/i.test(
                                                scope.row[item]
                                              )
                                                ? _c(
                                                    "el-popover",
                                                    {
                                                      staticStyle: {
                                                        "margin-right": "24px",
                                                      },
                                                      attrs: {
                                                        placement: "top-start",
                                                        trigger: "hover",
                                                      },
                                                    },
                                                    [
                                                      _c("ZImg", {
                                                        staticStyle: {
                                                          width: "250px",
                                                          height: "250px",
                                                        },
                                                        attrs: {
                                                          src: scope.row[item],
                                                        },
                                                      }),
                                                      _c("ZImg", {
                                                        staticClass:
                                                          "goods-image",
                                                        attrs: {
                                                          slot: "reference",
                                                          src: scope.row[item],
                                                        },
                                                        slot: "reference",
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$dataCheck(
                                                          scope.row[item]
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "template",
                                      { slot: "header" },
                                      [
                                        _vm._v(" " + _vm._s(item) + " "),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              placement: "top-start",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content",
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.optimizerTableConfig &&
                                                        _vm.optimizerTableConfig
                                                          .headerTooltip[item]
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c("i", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.optimizerTableConfig &&
                                                    _vm.optimizerTableConfig
                                                      .headerTooltip[item],
                                                  expression:
                                                    "optimizerTableConfig && optimizerTableConfig.headerTooltip[item]",
                                                },
                                              ],
                                              staticClass:
                                                "icon-a-01wenhao iconfont-el table-tooltip",
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            }
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("EditHeader", {
        attrs: { list: _vm.editColumns, info: _vm.editInfo },
        on: { change: _vm.changeTableColumns },
        model: {
          value: _vm.showEditHeader,
          callback: function ($$v) {
            _vm.showEditHeader = $$v
          },
          expression: "showEditHeader",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }